module.exports = __webpack_public_path__ + "static/img/bgimg.d2d510a5.jpg";